<script lang="ts">
  import { Button, TabContent, TabPane } from "sveltestrap";
  import { thirdsService } from "../services";
  import { Third } from "../Model/Third";
  import DirectionForm from "./DirectionForm.svelte";
  import AppWraper from "../components/AppWraper.svelte";
  import ThirdData from "../components/ThirdData.svelte";
  import ParentList from "../components/ParentList.svelte";
  import { v4 as v4uuid } from 'uuid';
  import { getCurrentUser } from "../services/session";
  import { navigate } from "svelte-navigator";
  import VehicleThirdList from "../components/VehicleThirdList.svelte";
  import { createEventDispatcher } from "svelte";

  export let thirdId: string;
  export let toggle: Function;

  let third: Third;
  
  
  const dispatch = createEventDispatcher();

  let thirdDataForm: ThirdData;
  let thirdAddressForm: DirectionForm;
  let thirdNotificationAddressForm: DirectionForm;

  $: loadThird(thirdId);

  async function loadThird(thirdId: string): Promise<void> {

    third = new Third({
            id: v4uuid(),
            photo: null,
            document: '',
            surname1: '',
            surname2: '',
            genderId: null,
            name: '',
            alias: '',
            email: '',
            phone1: '',
            phone2: '',
            birthday: '',
            dateOfDeath: '',
            addressId: v4uuid(),
            addressNotificationId: v4uuid(),
            registerUserId: getCurrentUser().id,
            creationDate: '',
            updatedDate: '',
            observations: '',
            is_lawyer: false,
            has_license: false,
            collegiate_num: null
        });
  }

  async function saveThird(){
      await Promise.all([
          thirdAddressForm.saveDirection(),
          thirdNotificationAddressForm.saveDirection(),
          thirdDataForm.saveThirdData()
      ])
      toggle();
      dispatch("changeThird", third.id);
  }

</script>

{#if third}
  <div class="container-fluid">
    <div class="container">
      <TabContent>
        <TabPane tabId="dataThird" tab="Datos" active>
          <div class="mt-3">
            <ThirdData bind:this={thirdDataForm} bind:thirdData={third} />
          </div>
        </TabPane>
        <TabPane tabId="dataDirection" tab="Direcciones">
          <div class="row mt-3">
            <div class="col-12 col-sm-9 mb-3">
              <div class="text-start">
                <h5>Dirección Principal</h5>
              </div>
            </div>
          </div>
          <DirectionForm
            bind:this={thirdAddressForm}
            thirdId={third.id}
            directionId={third.addressId}
          />
          <div class="row">
            <hr />
            <div class="col-12 col-sm-9 mb-3">
              <div class="text-start">
                <h5>Dirección de Notificación</h5>
              </div>
            </div>
            <div class="col-12 col-sm-3 mb-3">
              <div class="text-end">
                <Button
                  color="primary"
                  on:click={() =>
                    thirdNotificationAddressForm.cloneDirection(
                      third.addressId
                    )}
                >
                  Copiar Dirección
                </Button>
              </div>
            </div>
          </div>
          <DirectionForm
            bind:this={thirdNotificationAddressForm}
            thirdId={third.id}
            directionId={third.addressNotificationId}
          />
        </TabPane>
        <TabPane tabId="vehiclesThird" tab="Vehículos">
          <VehicleThirdList thirId={third.id} />
        </TabPane>
        <TabPane tabId="parentThird" tab="Relaciones">
          <ParentList thirId={third.id} />
        </TabPane>
        <TabPane tabId="diligenceThird" tab="Historial">
          <ParentList thirId={third.id} />
        </TabPane>
      </TabContent>
    </div>
    <Button color="success" on:click={() => saveThird()}>Guardar</Button>
  </div>
{/if}

<style>
</style>
